// Optimization to avoid bloating bootstrap code with unused code
export const DEFAULT_CURRENCY_CODE = 'EUR';
